import {observer} from 'mobx-react';
import {useDrop} from 'react-dnd';
import {FormattedMessage} from 'react-intl';
import ActionLink from 'shared/components/links/ActionLink';
import ShiftCard, {SHIFT_DRAG_TYPE} from './ShiftCard';
import TimeOffCard from './TimeOffCard';

const ShiftCell = observer(({uiState, employee, day}) => {
  const employeeId = employee.id;
  const [{isOver}, connectDrop] = useDrop({
    accept: SHIFT_DRAG_TYPE,
    hover: () => {
      uiState.hoveredCell = {employee, day};
    },
    drop: item => uiState.dropShift(item.shiftId, employee, day),
    collect: monitor => ({isOver: monitor.isOver()})
  });

  return (
    <div ref={connectDrop} className={`ShiftGrid-cell ${isOver ? 'ShiftGrid-cell--over' : ''} ${isOver && uiState.copyOnDrop ? 'ShiftGrid-cell--copying' : ''}`}>
      {uiState.schedule.timeOffSegmentsFor(employeeId, day).map(segment => <TimeOffCard key={segment.timeOff.id} {...segment}/>)}
      {uiState.schedule.shiftsFor(employeeId, day).map(shift => (
        <ShiftCard key={shift.id} uiState={uiState} shift={shift}/>
      ))}
      <ActionLink className='ShiftGrid-addShift' onClick={() => uiState.newShift(employee, day)}>
        <i className='material-symbols-solid'>{'add'}</i>
        <FormattedMessage id='time_tracking.shifts.Add Shift'/>
      </ActionLink>
    </div>
  );
});

export default ShiftCell;
